import type { SVGProps } from 'react';
const SvgRocket = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 29 29"
    fontSize="1rem"
    {...props}
  >
    <path
      fill="#FF073B"
      d="M26.074 1.896c-5.268-.662-10.401 1.265-14.306 4.978-5.6-.768-9.08 3.694-9.59 7.338a.446.446 0 0 0 .49.51l4.203-.511c.298.299.67.669 1.135 1.132l-.719 1.449a1.33 1.33 0 0 0 .252 1.53l2.497 2.497a1.33 1.33 0 0 0 1.53.251l1.447-.717 1.286 1.287c.14.14.354.169.525.076 1.386-.753 3.663-2.165 5.847-4.285.24 4.292-3.109 7.113-6.08 7.752l.196-1.606c.06-.582-.802-.684-.88-.107l-.27 2.22a.442.442 0 0 0 .51.49c3.432-.48 8.11-3.808 7.34-9.581 3.332-3.351 5.756-9.064 4.975-14.315a.44.44 0 0 0-.388-.388m-14.902 18.38a.44.44 0 0 1-.51-.083l-2.497-2.498a.44.44 0 0 1-.084-.51l.586-1.181 3.685 3.688zM25.448 7.158c-1.35 7.525-7.757 11.935-10.758 13.62-1.462-1.462-5.094-5.102-7.11-7.11.653-1.181 1.734-2.78 2.673-3.894.368-.447-.312-1.01-.683-.565-.981 1.158-2.16 2.912-2.816 4.123l-3.58.435c.306-1.244 1.247-3.845 3.915-5.244 1.901-.999 3.787-.894 4.742-.745a.47.47 0 0 0 .38-.11c3.65-3.527 8.44-5.453 13.409-4.93.146 1.495.089 2.98-.172 4.42M7.585 20.789c-3.06-2.725-5.77 2.653-5.812 5.325a.446.446 0 0 0 .47.47c2.667-.04 8.032-2.74 5.342-5.795m-.835 3.003a7.56 7.56 0 0 1-4.041 1.857 7.56 7.56 0 0 1 1.862-4.046c1.58-1.847 4.046.582 2.179 2.189"
    />
    <path
      fill="#FF073B"
      d="M15.663 7.66c-2.238 2.193-.616 6.11 2.518 6.078 3.136.026 4.751-3.873 2.517-6.079a3.565 3.565 0 0 0-5.035 0m4.409 4.408c-2.576 2.424-6.206-1.207-3.782-3.782 2.591-2.414 6.195 1.191 3.782 3.782"
    />
  </svg>
);
export default SvgRocket;
